import { SET_FORM_DATA, SET_FORM_VALUE } from 'actions';
import { GET_FORMS } from 'actions';
import { SET_FORM_TARGET } from 'actions';
import { SET_CURRENT_FORM } from 'actions';

const initState = {
  forms: null
}

export default function (state = initState, action) {
  switch (action.type) {

    case SET_FORM_DATA: {
      const { formData, target, valueState: givenValueState } = action.payload;
      const { sections } = formData;

      let valueState = {};
      if (givenValueState) {
        valueState = givenValueState;
      } else {
        sections.forEach(section => {
          const valueStateInSection = section.type === 'table' ? initSectionInTableType(section) : initWithSection(section, target);
          valueState = { ...valueState, [section.id]: valueStateInSection };
        })
      }
      return {
        ...state,
        ...action.payload.formData,
        target,
        valueState,
      };
    }

    case SET_FORM_VALUE: {
      return {
        ...state,
        valueState: action.payload
      };
    }

    case GET_FORMS: {
      return {
        ...state,
        ...action.payload
      };
    }

    case SET_FORM_TARGET: {
      const { sections } = state;
      const target = action.payload;
      let valueState = {};
      sections.forEach(section => {
        const valueStateInSection = section.type === 'table' ? initSectionInTableType(section) : initWithSection(section, target);
        valueState = { ...valueState, [section.id]: valueStateInSection };
      })
      return {
        ...state,
        target: action.payload,
        valueState,
      };
    }

    case SET_CURRENT_FORM: {
      return {
        ...state,
        current_form: action.payload
      };
    }

    default:
      return state;
  }
}


const initWithSection = (section, target) => {
  const { sections, questions } = section;
  let state = {};
  if (sections) {
    sections.forEach(section => {
      state = { ...state, [section.id]: initWithSection(section, target) };
    });
  }

  if (questions) {
    let questionStates = {};
    questions.forEach(question => {
      const { id, required, prefill } = question;
      const theValue = target && prefill ? target[prefill] : "";
      questionStates = {
        ...questionStates,
        [id]: theValue,
        [`${id}State`]: prefill
          ? "success"
          : required
            ? "error"
            : ""
      };
    });
    state = { ...state, ...questionStates };
  }

  console.log('state in initWithSection = ', state);
  return state;
}


const initSectionInTableType = section => {
  const { rows } = section;
  let state = {};
  rows.forEach(row => {
    const { id } = row;
    state = { ...state, [id]: "", [`${id}State`]: "error" };
  });
  return state;
}